/**
 * Created by ori on 20/09/16.
 */
export default () => ({});


// WEBPACK FOOTER //
// ./src/js/store/Verify.js